import { Form } from "@circle-react-uikit/Form";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { useCurrentPostHelpers } from "@/react/components/PostsV3/useCurrentPostHelpers";
import { FormToggleSwitch } from "@/react/components/SettingsApp/CompassCompat/FormToggleSwitch";
import { getImagePostFormPost } from "@/react/components/Spaces/ImageSpace/ImagePostModalCompass/CreatePost/helpers";
import { isPublishedPost } from "@/react/helpers/postHelpers";
import type { Space } from "@/react/types/Space";

interface TogglesProps {
  space?: Space;
}

export const Toggles = ({ space }: TogglesProps) => {
  const post = getImagePostFormPost(useCurrentPostHelpers().post);
  const { watch } = useFormContext<{ is_comments_disabled?: boolean }>();
  const isCommentsDisabled = watch("is_comments_disabled");
  const isEditingPublishedPost = Boolean(post?.id && isPublishedPost(post));

  const conditionalOptions: Record<string, boolean> = {
    hide_meta_info: true,
    is_comments_disabled: true,
    is_comments_closed: !isCommentsDisabled,
    is_liking_disabled: true,
    is_truncation_disabled: true,
    pin_to_top: isEditingPublishedPost,
    hide_from_featured_areas: !space?.hide_from_featured_areas,
    "gallery.downloadable_images": true,
  };

  const options = Object.entries(conditionalOptions).flatMap(
    ([key, shouldShow]) => (shouldShow ? [key] : []),
  );
  const toggleLabels: Record<string, () => string> = {
    hide_meta_info: () => t("post.hide_meta_info"),
    is_comments_disabled: () => t("post.is_comments_disabled"),
    is_comments_closed: () => t("post.is_comments_closed"),
    is_liking_disabled: () => t("post.is_liking_disabled"),
    is_truncation_disabled: () => t("post.is_truncation_disabled"),
    pin_to_top: () => t("post.pin_to_top"),
    hide_from_featured_areas: () => t("post.hide_from_featured_areas"),
    "gallery.downloadable_images": () => t("post.gallery.downloadable_images"),
  };

  return (
    <>
      {options.map(name => (
        <Form.Item
          id={`post_${name}`}
          key={name}
          name={name}
          label={toggleLabels[name]()}
          labelClassName="!font-normal !p-0"
          className="mb-3 !p-0"
          hideBorder
          hideDescription
          inlineReverse
        >
          <FormToggleSwitch name={name} variant="small" />
        </Form.Item>
      ))}
    </>
  );
};
